"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var __1 = require("../..");
var DataContext_1 = require("../DataContext");
function HeaderBulkAction(_a) {
    var bulkAction = _a.bulkAction;
    var checked = bulkAction.checked, onSelectAll = bulkAction.onSelectAll, placeholder = bulkAction.placeholder, disabled = bulkAction.disabled, options = bulkAction.options, getLabel = bulkAction.getLabel, onSelectAction = bulkAction.onSelectAction, actionElement = bulkAction.actionElement;
    var selectedRowsId = (0, DataContext_1.useDataContext)().selectedRowsId;
    var renderBulkAction = bulkAction
        ? bulkAction.checked === "indeterminate" || bulkAction.checked === true
        : false;
    var handleSelected = function (event) {
        onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll(event.checked);
    };
    if (!renderBulkAction) {
        return null;
    }
    return (React.createElement("div", { className: "nimbus--data-list__mass-actions" },
        React.createElement("div", { className: "nimbus--data-list__mass-actions-top" },
            React.createElement("div", { className: "nimbus--data-list-row__mass-check" },
                React.createElement(__1.Checkbox, { name: "all", checked: checked, onChange: handleSelected, label: getLabel((selectedRowsId === null || selectedRowsId === void 0 ? void 0 : selectedRowsId.length) || 0), disabled: disabled })),
            actionElement !== undefined && (React.createElement("div", { className: "nimbus--data-list-row__mass-custom" }, actionElement))),
        React.createElement("div", { className: "nimbus--data-list__mass-actions-bottom" },
            React.createElement("div", { className: "nimbus--data-list__mass-select" },
                React.createElement(__1.Select, { name: "select-mass-action", placeholder: placeholder, options: options, onChange: function (event) { return onSelectAction(event.value); } })))));
}
exports.default = HeaderBulkAction;
//# sourceMappingURL=HeaderBulkAction.js.map